module.exports = __webpack_public_path__ + "assets/img/2805.48d350b6.svg";